/**
 * Helper function to replace window.location.href
 *
 * This function provides a centralized way to handle location redirects,
 * making it easier to test and maintain navigation logic.
 *
 * @param url - The URL to navigate to
 */
export function replaceLocationHref(url: string): void {
  if (typeof window === "undefined") {
    // Server-side rendering - cannot redirect
    return;
  }

  window.location.href = url;
}
